// widgetResetSlice.ts
import { createSlice } from '@reduxjs/toolkit'

export interface WidgetState {
  progressStyles: Record<string, React.CSSProperties>
  loadingMap: Record<string, boolean>
}

const initialState: WidgetState = {
  progressStyles: {},
  loadingMap: {},
}

const widgetResetSlice = createSlice({
  name: 'widgetReset',
  initialState,
  reducers: {
    clearAllWidgetsState: state => {
      state.progressStyles = {}
      state.loadingMap = {}
    },
  },
})

export const { clearAllWidgetsState } = widgetResetSlice.actions
export default widgetResetSlice.reducer
